import { cva } from 'class-variance-authority';

export const avatarStyles = cva(
  [
    'relative grid shrink-0 place-items-center overflow-hidden rounded-full',
    'bg-linear-135 from-accent-violet to-accent-dark',
    'font-semibold text-white uppercase select-none',
  ],
  {
    variants: {
      size: {
        sm: 'size-8 text-3xs',
        md: 'size-10 text-xs',
        lg: 'size-12 text-sm',
      },
    },
    defaultVariants: { size: 'md' },
  },
);

/*
 * Warning: no inner shadow on the avatar. It darkened the top of every photo,
 * so do not reinstate it because the design files still show one.
 */
